import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Table, Modal, Tabs, Tab, Badge} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaCheck, FaFile, FaRegClock, FaExclamationCircle, FaFileInvoice, FaEdit, FaTrash } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import { formataDataHoraExibicao, getCurrentUser, formataCNPJ, formataCPF, formatarValor, aprovacaoNota, hasPerm, formatarValorAPI, formatarValorLocal, formatarValorAPISemDecimais } from '../../common/utils';

class FaturamentosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeArquivo = this.onChangeArquivo.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.state = {
            id: "",
            nota: "",
            nota_upload: "",
            laboratorio_id: "",
            data_envio: "",
            data_inicio: "",
            data_fim: "",
            valor_total: "",
            faturamento_credito_antecipacao: false,
            pago: false,
            pago_banco: false,
            data_pagamento: "",
            pagamento_comprovante: "",
            pagamento_comprovante_url: "",
            pagamento_forma_id: "",
            pagamento_url_cartao_credito: "",
            pagamento_chave_pix: "",
            pagamento_motivo_alteracao: "",
            nota_comissao_numero: "",
            nota_fiscal_status: "",
            nota_fiscal_motivo_recusa: "",
            nota_fiscal_motivo_recusa_banco: "",
            nota_fiscal_numero: "",
            data_vencimento: "",
            data_emissao: "",
            taxa_administrativa: "",
            taxa_administrativa_valor: "",
            tipo_pagamento: "",
            boleto_pagamento: "",
            boleto_pagamento_url: "",
            arquivo_dados_pagamento: "",
            arquivo_dados_pagamento_url: "",
            arquivo_comprovante_estorno_url: "",
            pagamento_banco: "",
            pagamento_agencia: "",
            pagamento_conta: "",
            pagamento_tipo_conta: "",
            pagamento_titular: "",
            programa_id: "",
            dados_laboratorio: {},
            dados_programa: {},
            lista_atendimentos: [],
            lista_historico_atendimentos: [],
            lista_historico_atendimentos_servicos: [],
            showModalAlteracaoAtendimento: false,
            showModalAlteracaoServico: false,
            showModalAlteracaoData: false,
            id_servico_data: '',
            data_servico_edicao: '',
            servicosPorAtendimento: {},
            formasPagamento: [ { pagamento_forma: null, forma_nome: '', slug: '' }],
            tipo_usuario: "",
            erroLoadRegistro: "",            
            titulo_pagina: "",
            loading: false,
            laboratorio_pagamento_forma_id: "",
            forma_atendimento_lab_selecionada: {},
            dados_credito_antecipacao: {},
            id_servico_atendimento: "",
            valor_servico_atendimento: 0,
            alteracao_servico_atendimento_titulo: "",
            tipo_faturamento: "",
            atendimentos_servicos: [],
            carregamentoAbas: [],
            logs_faturamento: [],
            dados_prestador: {},
            is_superuser: false,
            data_criacao: '',
            ordem_pagamento: '',
            observacoes: '',
            origem_exame_avulso: false,
        };

        this.statusConfig = {
            aguardando: { background: '#f2f2f2', color: '#252f4a', text: 'Aguardando Envio Prestador', icon: <FaRegClock /> },
            analise: { background: '#f2f2f2', color: '#252f4a', text: 'Em Análise', icon: <FaRegClock /> },
            recusado: { background: '#eb4961', color: '#fff', text: 'Recusado', icon: <FaExclamationCircle /> },
            aprovado: { background: '#3cc172', color: '#fff', text: 'Aprovado', icon: <FaCheck /> }
        };
    }

    getCamposDinamicosPagamentoPorSlug = () => ({
        pix: ['pagamento_chave_pix'],
        'cartao-de-credito': ['pagamento_url_cartao_credito'],
        'transferencia-bancaria': [
            'pagamento_banco',
            'pagamento_agencia',
            'pagamento_tipo_conta',
            'pagamento_conta',
            'pagamento_titular',
        ],
        boleto: ['boleto_pagamento'],
    });

    limparCamposDinamicosPagamento = (slugSelecionado) => {
        const camposPorSlug = this.getCamposDinamicosPagamentoPorSlug();
        const camposSelecionados = new Set(camposPorSlug[slugSelecionado] || []);
        const todosCampos = Object.values(camposPorSlug).flat();
        const updates = {};

        todosCampos.forEach((campo) => {
            if (!camposSelecionados.has(campo)) {
                updates[campo] = campo === 'boleto_pagamento' ? null : '';
            }
        });

        return updates;
    };

    componentDidMount(){
        const id = this.props.router.params.id;
        let dados_usuario = getCurrentUser();

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario,
            is_superuser: dados_usuario.is_superuser,
        })        

        if(id){
            this.setState({
                id: id,
                titulo_pagina: 'Faturamento',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do faturamento na api
            api.get(`/faturamento/${id}`)
            .then(response => {
                const dados = response.data;
                const formaPagamentoAtendimento = (dados.dados_laboratorio_pagamento_forma && Object.keys(dados.dados_laboratorio_pagamento_forma).length > 0)
                    ? dados.dados_laboratorio_pagamento_forma
                    : (dados.dados_pagamento_forma || {});
                const formaPagamentoId = dados.laboratorio_pagamento_forma_id || dados.pagamento_forma_id || '';

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',                    
                    loading: false,
                    nota: dados.nota,
                    laboratorio_id: dados.laboratorio_id,
                    data_envio: dados.data_envio,
                    data_inicio: dados.data_inicio,
                    data_fim: dados.data_fim,
                    valor_total: dados.valor_total,
                    pago: dados.pago,
                    pago_banco: dados.pago,
                    data_pagamento: dados.data_pagamento,
                    pagamento_comprovante_url: dados.pagamento_comprovante,
                    pagamento_forma_id: dados.pagamento_forma_id || formaPagamentoId,
                    pagamento_url_cartao_credito: dados.pagamento_url_cartao_credito,
                    pagamento_chave_pix: dados.pagamento_chave_pix,
                    pagamento_motivo_alteracao: dados.pagamento_motivo_alteracao,
                    laboratorio_pagamento_forma_id: formaPagamentoId,
                    forma_atendimento_lab_selecionada: formaPagamentoAtendimento,
                    nota_fiscal_status: dados.nota_fiscal_status,
                    nota_fiscal_motivo_recusa: dados.nota_fiscal_motivo_recusa,
                    nota_fiscal_motivo_recusa_banco: dados.nota_fiscal_motivo_recusa,
                    nota_fiscal_numero: dados.nota_fiscal_numero,
                    data_vencimento: dados.data_vencimento,
                    data_emissao: dados.data_emissao,
                    nota_comissao_numero: dados.nota_comissao_numero,
                    taxa_administrativa: dados.taxa_administrativa,
                    taxa_administrativa_valor: dados.taxa_administrativa_valor,
                    boleto_pagamento_url: dados.boleto_pagamento,
                    arquivo_dados_pagamento_url: dados.arquivo_dados_pagamento,
                    arquivo_comprovante_estorno_url: dados.arquivo_comprovante_estorno,
                    pagamento_banco: dados.pagamento_banco,
                    pagamento_agencia: dados.pagamento_agencia,
                    pagamento_conta: dados.pagamento_conta,
                    pagamento_tipo_conta: dados.pagamento_tipo_conta,
                    pagamento_titular: dados.pagamento_titular,
                    programa_id: dados.programa_id,
                    dados_laboratorio: dados.dados_laboratorio,
                    //dados_programa: dados.dados_programa,
                    lista_atendimentos: dados.lista_atendimentos,
                    faturamento_credito_antecipacao: (dados.dados_credito_antecipacao && dados.dados_credito_antecipacao.length > 0) ? true : false,
                    dados_credito_antecipacao: dados.dados_credito_antecipacao,
                    lista_historico_atendimentos: dados.dados_historico_atendimentos,
                    lista_historico_atendimentos_servicos: dados.dados_historico_atendimentos_servicos,
                    cancelado: dados.cancelado,
                    data_criacao: dados.data_criacao,
                    ordem_pagamento: dados.ordem_pagamento,
                    observacoes: dados.observacoes,
                    origem_exame_avulso: !!dados.origem_exame_avulso,
                }, () => {
                    if(this.state.lista_atendimentos.length > 0){
                        this.setState({
                            valor_total: 0
                        }, () => {
                            this.setState({
                                valor_total: this.state.lista_atendimentos.reduce((total, servico) => total + parseFloat(servico.valor_atendimento || servico.valor || 0), parseFloat(this.state.valor_total || 0))
                            })
                        })
                    }
                    
                    this.carregaDadosPrestador();
                    this.carregaDadosPrograma(this.state.programa_id);
                })
                this.carregarFormasPagamento()
                //this.carregarServicos()
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar o faturamento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        
    }

    // helper para calcular e persistir os totais no faturamento
    atualizaTotaisFaturamento = async () => {
        const faturamentoId = this.state.id || this.props.match?.params?.id;

        // 1) GET faturamento para obter a lista atualizada de atendimentos
        const resp = await api.get(`/faturamento/${faturamentoId}`);
        const dados = resp.data;

        // 2) Soma dos atendimentos (valor_atendimento || valor)
        const total = (dados.lista_atendimentos || []).reduce((acc, item) => {
            const v = parseFloat(item.valor_atendimento ?? item.valor ?? 0) || 0;
            return acc + v;
        }, 0);

        // 3) PUT no faturamento salvando "valor_total" e "nota_fiscal_valor"
        const fd = new FormData();
        fd.append('valor_total', total);
        fd.append('nota_fiscal_valor', total);

        await api({
            method: 'put',
            url: `/faturamento/${faturamentoId}/`,
            data: fd,
        });
    };

    handleChangeAtendimento = (e, index, fieldName) => {   

        let { name, value } = e.target;
        const { atendimentos_servicos } = this.state;

        if(fieldName == 'valor'){
            value = formatarValor(value);
        }

        const updatedAtendimentosServicos = [...atendimentos_servicos];
        updatedAtendimentosServicos[index][name] = value;

        this.setState({
            atendimentos_servicos: updatedAtendimentosServicos
        });

    }   

    quebraLinhaHistorico = (descricao) => {
        return descricao
    }

    alterarValorServicoAtendimento = (id, tipo_faturamento, valor) => {
        if(tipo_faturamento == 'atendimento'){ 
            //busca os atendimentos
            api.get(`/atendimentos/servicos/?atendimento_id=${id}`)
            .then(response => {
                const dados = response.data;

                this.setState({
                    atendimentos_servicos: dados.results.map(servico => ({
                        ...servico,
                        valor: servico.valor ? formatarValor(servico.valor) : ''
                    }))
                });

                this.setState({
                    showModalAlteracaoAtendimento: true,
                    id_servico_atendimento: id,
                    valor_anterior: valor,
                    valor_servico_atendimento: formatarValor(valor),
                    alteracao_servico_atendimento_titulo: 'Alterar Valor do Atendimento',
                    tipo_faturamento: tipo_faturamento
                })
            })
            .catch(error => {
                console.error('Erro ao carregar atendimento:', error);
                Swal.fire('Erro!', 'Não foi possível carregar o atendimento.', 'error');
            });
        } else {
            this.setState({
                showModalAlteracaoServico: true,
                id_servico_atendimento: id,
                valor_servico_atendimento: valor,
                alteracao_servico_atendimento_titulo: 'Alterar Valor do Serviço',
                tipo_faturamento: tipo_faturamento
            })
        }
    }

    enviaRegistroAlteracaoAtendimento = (e) => {
        e.preventDefault();
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: <p>Deseja realmente salvar as alterações?</p>,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            showCloseButton: true,
        }).then(async (result) => {
            if (!result.isConfirmed) return;

            this.setState({ loading: true });

            try {
                // Cria um array de Promises para aguardar tudo
                const requests = this.state.atendimentos_servicos.map((servico) => {
                    // 1) PUT do serviço
                    const fdServico = new FormData();
                    fdServico.append('valor', formatarValorAPI(servico.valor));
                    fdServico.append('valor_anterior', formatarValorAPI(this.state.valor_anterior));
                    fdServico.append('valor_total_anterior', this.state.valor_total);

                    const putServico = api({
                        method: 'put',
                        url: `/atendimentos/servicos/${servico.id}/`,
                        data: fdServico,
                    });

                    // 2) Se faturamento for por atendimento, PUT no atendimento com valor_atendimento
                    if (this.state.tipo_faturamento === 'atendimento') {
                        const fdAtendimento = new FormData();
                        fdAtendimento.append('valor_atendimento', formatarValorAPI(servico.valor));

                        const putAtendimento = api({
                            method: 'put',
                            url: `/atendimentos/${this.state.id_servico_atendimento}/`,
                            data: fdAtendimento,
                        });

                        // Retorna uma Promise que aguarda os dois PUTs
                        return Promise.all([putServico, putAtendimento]);
                    }

                    // Caso contrário, só o PUT do serviço
                    return putServico;
                });

                // Aguarda todas as requisições
                await Promise.all(requests);

                if (this.state.tipo_faturamento === 'atendimento') {
                    await this.atualizaTotaisFaturamento();
                }

                await MySwal.fire({
                    title: <p>Valor alterado com sucesso</p>,
                    icon: 'success',
                    showCloseButton: true,
                });

                window.location.reload();
            } catch (error) {
                console.error('Erro ao salvar alterações:', error);
                this.setState({ loading: false });
                MySwal.fire({
                    title: <p>Ocorreu um erro ao salvar</p>,
                    text: 'Tente novamente ou verifique sua conexão.',
                    icon: 'error',
                    showCloseButton: true,
                });
            }
        });
    };

    enviaRegistroAlteracaoServicoAtendimento = (e) => {
        e.preventDefault();

        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: <p>Deseja realmente alterar o valor?</p>,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    loading: true,
                });

                const formData = new FormData();
                formData.append('valor', formatarValorAPI(this.state.valor_servico_atendimento));
                formData.append('tipo_faturamento', this.state.tipo_faturamento);
                formData.append('valor_total_anterior', this.state.valor_total);
                let url = `/atendimentos/servicos/${this.state.id_servico_atendimento}/`;

                api({
                    method: 'put',
                    url: url,
                    data: formData,
                })
                .then(response => {
                    this.setState({
                        loading: false,
                        showModalAlteracaoServicoAtendimento: false
                    });

                    MySwal.fire({
                        title: <p>Valor alterado com sucesso</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then((result) => {
                        window.location.reload();
                    });             
                })
                .catch(error => {
                    let erro_msg = 'Erro ao alterar o valor, tente novamente';            

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    });

                    this.setState({
                        loading: false,
                    });
                });
            }
        });
    }

    carregaDadosPrograma = (programa_id) => {
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    let dadosResponse = response.data;

                    // Verifica condição especial para o programa IDHentifique (se for faturamento mais antigo que a data de 2025-10-11 então deve tratar o tipo_faturamento como atendimento)
                    if (dadosResponse?.nome === 'Servier - IDHentifique') {
                        const dataCriacao = new Date(this.state.data_criacao);
                        const dataLimite = new Date("2025-10-11");

                        if (dataCriacao < dataLimite) {
                            // Mantém o tipo antigo
                            dadosResponse.tipo_faturamento = "atendimento";
                        } 
                    }

                    this.setState({ dados_programa: dadosResponse });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                });
        }
    };

    carregaDadosPrestador = () => {
        if (hasPerm('view_prestadores') && this.state.laboratorio_id) {
            api.get(`/pessoas/prestadores/${this.state.laboratorio_id}/`)
                .then(response => {
                    const dadosResponse = response.data;
                    this.setState({ dados_prestador: dadosResponse });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do prestador', error);
                    //Sentry.captureException('Erro ao carregar dados do programa atual:', error);
                    
                    let erro_msg = 'Erro ao carregar dados do prestador, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const MySwal = withReactContent(Swal);
        const origemExameAvulso = !!this.state.origem_exame_avulso;
        // Para avulso, só considera pagamento concluído quando já estiver persistido no backend.
        const pagamentoAvulsoConcluido = origemExameAvulso
            ? (!!this.state.pago_banco && !!this.state.pagamento_comprovante_url && !!this.state.data_pagamento)
            : (!!this.state.pago && (!!this.state.pagamento_comprovante || !!this.state.pagamento_comprovante_url));
        const tentandoEnviarDadosFiscais = !!(
            this.state.nota_upload
            || this.state.nota_fiscal_numero
            || this.state.data_emissao
            || this.state.data_vencimento
        );

        if( this.state.tipo_usuario === "prestador" ) {
            if((!origemExameAvulso || pagamentoAvulsoConcluido) && !this.state.nota_upload && (!this.state.nota_fiscal_status || this.state.nota_fiscal_status === 'recusado')) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Por favor, o envio da nota fiscal é obrigatório',
                    showCloseButton: true,
                });
                return;
            }

            if((!origemExameAvulso || pagamentoAvulsoConcluido) && !this.state.nota_fiscal_numero) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Por favor, informe o número da nota fiscal',
                    showCloseButton: true,
                });
                return;
            }

            if((!origemExameAvulso || pagamentoAvulsoConcluido) && !this.state.data_emissao) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Por favor, informe a data de emissão',
                    showCloseButton: true,
                });
                return;
            }

            if((!origemExameAvulso || pagamentoAvulsoConcluido) && !this.state.data_vencimento) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Por favor, informe a data de vencimento',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.laboratorio_pagamento_forma_id) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Por favor, selecione uma forma de pagamento',
                    showCloseButton: true,
                });
                return;
            }

        }

        if (origemExameAvulso && !pagamentoAvulsoConcluido && tentandoEnviarDadosFiscais) {
            MySwal.fire({
                icon: 'warning',
                title: <p>Atenção</p>,
                text: 'Para faturamento de exame avulso, registre o pagamento com comprovante antes de enviar a nota fiscal.',
                showCloseButton: true,
            });
            return;
        }

        if (this.state.pago) {
            
            if(!this.state.data_pagamento) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Data do pagamento deve ser informada.',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.pagamento_comprovante && !this.state.pagamento_comprovante_url) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Um comprovante de pagamento deve ser anexado.',
                    showCloseButton: true,
                });
                return;
            }

            if(!origemExameAvulso && !this.state.nota_comissao_numero) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Informe o número da Nota Fiscal de Comissão.',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.pagamento_forma_id) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'A forma de pagamento deve ser informada.',
                    showCloseButton: true,
                });
                return;
            }

            if(this.state.pagamento_forma_id && this.state.pagamento_forma_id != this.state.laboratorio_pagamento_forma_id && !this.state.pagamento_motivo_alteracao) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>Atenção</p>,
                    text: 'Informe um motivo para alteração da forma de pagamento.',
                    showCloseButton: true,
                });
                return;
            }
            
        }
    
        const formData = new FormData();
    
        this.setState({
            loading: true,
        });
    
        const podeEnviarDadosFiscais = !origemExameAvulso || pagamentoAvulsoConcluido;

        if (podeEnviarDadosFiscais) {
            if (this.state.nota_upload) {
                formData.append('nota', this.state.nota_upload);
                formData.append('nota_fiscal_status', 'analise');
            } else {
                if (this.state.nota_fiscal_status) {
                    formData.append('nota_fiscal_status', this.state.nota_fiscal_status);
                }
            }
        }
    
        if (this.state.data_pagamento) {
            formData.append('data_pagamento', this.state.data_pagamento);
        }
    
        formData.append('pago', this.state.pago);

        if (this.state.pagamento_forma_id) {
            formData.append('pagamento_forma_id', this.state.pagamento_forma_id);
        }

        if (this.state.pagamento_comprovante) {
            formData.append('pagamento_comprovante', this.state.pagamento_comprovante);
        }
        
        if (podeEnviarDadosFiscais && this.state.nota_fiscal_motivo_recusa) {
            formData.append('nota_fiscal_motivo_recusa', this.state.nota_fiscal_motivo_recusa);
        }
        if (podeEnviarDadosFiscais && this.state.nota_fiscal_numero) {
            formData.append('nota_fiscal_numero', this.state.nota_fiscal_numero);
        }
        if (podeEnviarDadosFiscais && this.state.data_vencimento) {
            formData.append('data_vencimento', this.state.data_vencimento);
        }
        if (podeEnviarDadosFiscais && this.state.data_emissao) {
            formData.append('data_emissao', this.state.data_emissao);
        }
        if (this.state.boleto_pagamento) {
            formData.append('boleto_pagamento', this.state.boleto_pagamento);
        }
        if (this.state.arquivo_dados_pagamento) {
            formData.append('arquivo_dados_pagamento', this.state.arquivo_dados_pagamento);
        }
        if (this.state.pagamento_banco) {
            formData.append('pagamento_banco', this.state.pagamento_banco);
        }
        if (this.state.pagamento_agencia) {
            formData.append('pagamento_agencia', this.state.pagamento_agencia);
        }
        if (this.state.pagamento_conta) {
            formData.append('pagamento_conta', this.state.pagamento_conta);
        }
        if (this.state.pagamento_tipo_conta) {
            formData.append('pagamento_tipo_conta', this.state.pagamento_tipo_conta);
        }
        if (this.state.pagamento_titular) {
            formData.append('pagamento_titular', this.state.pagamento_titular);
        }
        if (this.state.pagamento_chave_pix) {
            formData.append('pagamento_chave_pix', this.state.pagamento_chave_pix);
        }
        if (this.state.pagamento_url_cartao_credito) {
            formData.append('pagamento_url_cartao_credito', this.state.pagamento_url_cartao_credito);
        }
        if (this.state.pagamento_motivo_alteracao) {
            formData.append('pagamento_motivo_alteracao', this.state.pagamento_motivo_alteracao);
        }
        if (this.state.nota_comissao_numero) {
            formData.append('nota_comissao_numero', this.state.nota_comissao_numero);
        }

        if (this.state.laboratorio_pagamento_forma_id) {
            formData.append('laboratorio_pagamento_forma_id', this.state.laboratorio_pagamento_forma_id);
        }
    
        // Envia para API
        api({
            method: 'put',
            url: '/faturamento/' + this.state.id + '/',
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
    
            this.setState({
                loading: false,
            });
    
            MySwal.fire({
                title: <p>Faturamento atualizado com sucesso</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                window.location.reload();
            });             
        })
        .catch(error => {
            let erro_msg = 'Erro ao atualizar o faturamento, verifique os campos e tente novamente';            
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });
    
            this.setState({
                loading: false,
            });
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === "valor" || name === "valor_servico_atendimento") {
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } 
        else if(name == 'pago'){
            this.setState({
                pago: e.target.checked,
            })
        }
        else if(name == 'laboratorio_pagamento_forma_id'){
            const objForma = this.state.formasPagamento.find(obj => obj.id == value);

            let formaSelecionada = {}
            if(objForma){
                formaSelecionada = objForma
            }

            const limparCampos = this.limparCamposDinamicosPagamento(objForma?.slug);

            this.setState({ 
                laboratorio_pagamento_forma_id: value,
                forma_atendimento_lab_selecionada: formaSelecionada,
                ...limparCampos,
            });
        }
        else {
            this.setState({ [name]: value });
        }
    };

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const nota_upload = e.target.files[0];
            
            // Armazena o arquivo para upload
            this.setState({ nota_upload: nota_upload, nota_fiscal_numero: "" });
        }
    };

    carregarFormasPagamento = async () => {
        try {
            const response = await api.get('/formas-pagamento/');
            const formasPagamento = response.data.results.map(formaPagamento => ({
                id: formaPagamento.id,
                nome: formaPagamento.nome,
                slug: formaPagamento.slug,
            }));
            this.setState({ formasPagamento }, () => {
                const formaSemSlug = !this.state.forma_atendimento_lab_selecionada || !this.state.forma_atendimento_lab_selecionada.slug;
                const formaSelecionadaId = this.state.laboratorio_pagamento_forma_id || this.state.pagamento_forma_id;

                if (formaSemSlug && formaSelecionadaId) {
                    const formaSelecionada = formasPagamento.find(forma => String(forma.id) === String(formaSelecionadaId));

                    if (formaSelecionada) {
                        this.setState({
                            forma_atendimento_lab_selecionada: formaSelecionada,
                            laboratorio_pagamento_forma_id: this.state.laboratorio_pagamento_forma_id || formaSelecionada.id,
                            pagamento_forma_id: this.state.pagamento_forma_id || formaSelecionada.id,
                        });
                    }
                }
            });
        } catch (error) {
            console.error('Erro ao carregar formas de pagamento:', error);
        }
    };

    handleFormaPagamentoChange = (e) => {
        const { name, value } = e.target;
        const objForma = (this.state.formasPagamento || []).find(obj => String(obj.id) === String(value));
        const limparCampos = this.limparCamposDinamicosPagamento(objForma?.slug);
        this.setState(prevState => ({
            [name]: value,
            ...limparCampos,
            ...(name === 'pagamento_forma_id' && prevState.origem_exame_avulso ? {
                forma_atendimento_lab_selecionada: objForma || {},
            } : {})
        }));
    };

    handleComprovanteChange = (e) => {
        const file = e.target.files[0];
    
        if (file && file.type !== "application/pdf") {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: <p>Arquivo inválido</p>,
                text: 'Selecione um arquivo PDF válido.',
                showCloseButton: true,
            });
            return;
        }
        this.setState({ pagamento_comprovante: file });
        if (file) {
            const url = URL.createObjectURL(file);
            this.setState({ pagamento_comprovante_url: url });
        }
    };

    handleNotaStatusChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleNotaRecusaChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleNotaNumeroChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleTipoPagamentoChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleBoletoChange = (e) => {
        const file = e.target.files[0];
    
        if (file && file.type !== "application/pdf") {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: <p>Arquivo inválido</p>,
                text: 'Selecione um arquivo PDF válido.',
                showCloseButton: true,
            });
            return;
        }
        this.setState({ boleto_pagamento: file });
        if (file) {
            const url = URL.createObjectURL(file);
            this.setState({ boleto_pagamento_url: url });
        }
    }

    handleArquivoDadosPagamentoChange = (e) => {
        const file = e.target.files[0];

        if (file && file.type !== "application/pdf") {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: <p>Arquivo inválido</p>,
                text: 'Selecione um arquivo PDF válido.',
                showCloseButton: true,
            });
            return;
        }
        this.setState({ arquivo_dados_pagamento: file });
        if (file) {
            const url = URL.createObjectURL(file);
            this.setState({ arquivo_dados_pagamento_url: url });
        }
    }

    handleTransferenciasChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    carregarServicos =  (atendimentoId) => {
        if (this.state.servicosPorAtendimento[atendimentoId]) {
            return;
        }

        api.get(`/atendimentos/servicos/?atendimento_id=${atendimentoId}`)
            .then((response) => {
                const servicos = Array.isArray(response.data.results) ? response.data.results : [];
                this.setState((prevState) => ({
                    servicosPorAtendimento: {
                        ...prevState.servicosPorAtendimento,
                        [atendimentoId]: servicos, 
                    },
                }));
            })
            .catch((error) => {
                console.error("Erro ao carregar serviços:", error);
            });
    };

    getLogsFaturamento = async () => {
        await api.get(`/logs/?faturamento_id=${this.state.id}`)
        .then(response => {
            this.setState({ 
                logs_faturamento: response.data.results,
            });
        })
        .catch(error => {
            console.error('Erro ao carregar logs do faturamento:', error);
            Sentry.captureException('Erro ao carregar logs do faturamento:', error);                                
        });
    }

    excluirServicoAtendimento = (servico) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'warning',
            title: <p>Atenção</p>,
            text: 'Tem certeza que deseja excluir o serviço ' + servico.servico_procedimento__nome + ' (ID: ' + servico.id + ')?',
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                api.put(`/atendimentos/servicos/${servico.id}/`, {
                    excluir_faturamento: true,
                })
                .then(response => {
                    MySwal.fire({
                        icon: 'success',
                        title: <p>Serviço excluído do faturamento com sucesso</p>,
                        showCloseButton: true,
                    }).then((result) => {
                        window.location.reload();
                    });
                })
                .catch(error => {
                    console.error('Erro ao excluir serviço do faturamento:', error);
                });
            }
        });
    }

    abrirModalAlteracaoData = (servico) => {
        const dataServico = servico.data || servico.agendamento__data_realizacao || '';
        this.setState({
            showModalAlteracaoData: true,
            id_servico_data: servico.id,
            data_servico_edicao: dataServico ? dataServico.substring(0, 16) : '',
        });
    }

    enviaRegistroAlteracaoData = (e) => {
        e.preventDefault();

        const MySwal = withReactContent(Swal);

        if (!this.state.data_servico_edicao) {
            MySwal.fire({
                icon: 'error',
                title: <p>Atenção</p>,
                text: 'É obrigatório o preenchimento da data',
                showCloseButton: true,
            });
            return;
        }

        MySwal.fire({
            title: <p>Deseja realmente alterar a data?</p>,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });

                api.put(`/atendimentos/servicos/${this.state.id_servico_data}/`, {
                    data: this.state.data_servico_edicao,
                })
                .then(response => {
                    this.setState({
                        loading: false,
                        showModalAlteracaoData: false,
                    });

                    MySwal.fire({
                        title: <p>Data alterada com sucesso</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then(() => {
                        window.location.reload();
                    });
                })
                .catch(error => {
                    let erro_msg = 'Erro ao alterar a data, tente novamente';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    });

                    this.setState({ loading: false });
                });
            }
        });
    }

    handleSelectTab = async (aba) => {
        if (this.state.carregamentoAbas.length > 0) {
            const containsAba = this.state.carregamentoAbas.some(item => item.nome === aba);
            if(containsAba){
                return;
            }
        }

        this.setState({
            loading: true
        });
        
        try {
            // Executa as requisições de forma assíncrona
            switch (aba) {

                case "logsFaturamento":
                    await this.getLogsFaturamento();
                    break;
    
                default:
                    break;
            }
    
            // Após todas as funções terminarem com sucesso, define loading como false
            this.setState({
                loading: false
            });

            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,  // espalha os itens existentes
                    { nome: aba, status: true }     // adiciona o novo item ao final
                ]
            }));
    
        } catch (error) {
            // Caso algum erro aconteça, define loading como false
            console.error("Erro ao carregar os dados:", error);
            this.setState({
                loading: false
            });
        }
    }

    render(){
        const dados_usuario = getCurrentUser();
        const statusLabel = this.state.nota_fiscal_status ? (this.statusConfig[this.state.nota_fiscal_status] || this.statusConfig['analise']) : this.statusConfig['analise'];
        const currentDate = new Date().toISOString().split('T')[0];
        const servicosRelacionados = this.state.lista_atendimentos || [];
        const origemExameAvulso = !!this.state.origem_exame_avulso || servicosRelacionados.some(item => item.exame_solicitado_id);
        // Para avulso, libera dados fiscais somente após confirmação de pagamento salva no backend.
        const pagamentoAvulsoConcluido = origemExameAvulso
            ? (!!this.state.pago_banco && !!this.state.pagamento_comprovante_url && !!this.state.data_pagamento)
            : (!!this.state.pago && (!!this.state.pagamento_comprovante || !!this.state.pagamento_comprovante_url));
        const bloquearDadosFiscaisPorPagamento = origemExameAvulso && !pagamentoAvulsoConcluido;
        const bloquearEdicaoPorPagoBanco = !origemExameAvulso && this.state.pago_banco;
        const bloquearEdicaoPorPago = !origemExameAvulso && this.state.pago;
        const exibirControlesPagamentoInterno = origemExameAvulso || this.state.nota_fiscal_status === "aprovado";
        const exibirTabelaServicos = origemExameAvulso || this.state.dados_programa.tipo_faturamento === 'servico';
        const exibirNotaComissao = !origemExameAvulso;
        const exibirCamposFormaPagamento = this.state.tipo_usuario === 'prestador' || !!this.state.pago;
        const formaPagamentoAtiva = (this.state.formasPagamento || []).find(forma =>
            String(forma.id) === String(this.state.pagamento_forma_id || this.state.laboratorio_pagamento_forma_id)
        ) || ((this.state.forma_atendimento_lab_selecionada && this.state.forma_atendimento_lab_selecionada.slug)
            ? this.state.forma_atendimento_lab_selecionada
            : null);

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosFaturamento" id="tabs-faturamento" className="aditus-tabs" onSelect={this.handleSelectTab}>
                    <Tab eventKey="dadosFaturamento" title="Dados do Faturamento">
                        <Card className="cardDestaque">
                            <Card.Body>    
                                <h4>Dados do Faturamento</h4>
                                <Form onSubmit="">
                                    <Row>  
                                        <Col sm={6} xs={12}>
                                            <label>OS: </label>
                                            <span>
                                                {this.state.id} –{' '}
                                                <Badge className={this.state.cancelado ? 'bg-danger' : 'bg-info'}>
                                                    {this.state.cancelado ? 'Cancelado' : 'Ativo'}
                                                </Badge>
                                                {this.state.cancelado && this.state.arquivo_comprovante_estorno_url && (
                                                    <a
                                                        className="btn btn-outline-secondary btn-sm ms-2"
                                                        href={this.state.arquivo_comprovante_estorno_url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <FaFile /> Ver comprovante de estorno
                                                    </a>
                                                )}
                                            </span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Data do envio: </label>
                                            <span> {formataDataHoraExibicao(this.state.data_envio)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Data de início: </label>
                                            <span> {formataDataHoraExibicao(this.state.data_inicio)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Data final: </label>
                                            <span> {formataDataHoraExibicao(this.state.data_fim)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Prestador: </label>
                                            <span> {this.state.dados_laboratorio.nome} (CNPJ: <b>{formataCNPJ(this.state.dados_laboratorio.cpf_cnpj)}</b>)</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Programa: </label>
                                            <span> {this.state.dados_programa.nome}</span>
                                        </Col>   
                                        <Col sm={6} xs={12}>
                                            <label>Valor: </label>
                                            <span> {parseFloat(this.state.valor_total).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</span>
                                            {this.state.faturamento_credito_antecipacao && (
                                                <span>
                                                    <span className="text-danger"> <b>(Esse é um faturamento de crédito antecipado)</b></span>
                                                </span>
                                            )}
                                        </Col>
                                        {this.state.tipo_usuario !== 'prestador' && (
                                        <Col sm={6} xs={12}>
                                            <label>Taxa Administrativa: </label>
                                            {this.state.taxa_administrativa_valor && (
                                            <span>
                                                &nbsp;{this.state.taxa_administrativa_valor 
                                                ? parseFloat(this.state.taxa_administrativa_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                                : ''}
                                            &nbsp;({this.state.taxa_administrativa 
                                                ? parseFloat(this.state.taxa_administrativa).toLocaleString('pt-BR')
                                                : ''}%)
                                            </span>
                                            )}
                                        </Col>
                                        )}

                                        <Col sm={6} xs={12}>
                                            <label>Pago: </label>
                                            <span> {this.state.pago ? 'Sim' : 'Não'}</span>
                                        </Col>
                                        {this.state.pago && this.state.data_pagamento && (
                                        <Col sm={6} xs={12}>
                                            <label>Data do Pagamento: </label>
                                            <span> {this.state.data_pagamento ? formataDataHoraExibicao(this.state.data_pagamento) : '---'}</span>                                        
                                        </Col>
                                        )}
                                        {this.state.nota && this.state.nota_fiscal_status && (
                                        <Col sm={6} xs={12}>
                                            <label>Status da Nota Fiscal: </label>
                                            <span
                                                style={{
                                                    backgroundColor: statusLabel.background,
                                                    color: statusLabel.color,
                                                    padding: '5px 10px',
                                                    fontSize: '12px',
                                                    borderRadius: '5px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    display: 'inline-block',
                                                    marginLeft: '10px'
                                                }}
                                            >
                                                {statusLabel.icon}
                                                <span style={{ marginLeft: '5px' }}>{statusLabel.text}</span>
                                            </span>
                                        </Col>
                                        )}  
                                        {!this.state.nota && (
                                            <Col sm={6} xs={12}>
                                                <label>Status da Nota Fiscal: </label>
                                                <span
                                                    style={{
                                                        backgroundColor: statusLabel.background,
                                                        color: statusLabel.color,
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                        borderRadius: '5px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        display: 'inline-block',
                                                        marginLeft: '10px'
                                                    }}
                                                >
                                                    {statusLabel.icon}
                                                    <span style={{ marginLeft: '5px' }}>{origemExameAvulso && !pagamentoAvulsoConcluido ? 'Aguardando Pagamento' : 'Aguardando Envio Prestador'}</span>
                                                </span>
                                            </Col>
                                        )}                      
                                    </Row>
                                    {this.state.ordem_pagamento && (
                                    <>
                                        <Row className="mt-3 mb-3">
                                            <Col sm={12} xs={12}>
                                                <label>Ordem de Pagamento: </label>
                                                <span> {this.state.ordem_pagamento ? this.state.ordem_pagamento : '---'}</span>                      
                                            </Col>
                                        </Row>
                                    </>
                                    )}
                                    {this.state.nota_fiscal_status === "recusado" && this.state.nota_fiscal_motivo_recusa_banco && (
                                    <>
                                        <Row className="mt-3 mb-3">
                                            <Col sm={12} xs={12}>
                                                <Alert className="alert-warning">
                                                    <label><FaExclamationCircle /> Motivo da Recusa: </label>
                                                    <span> {this.state.nota_fiscal_motivo_recusa ? this.state.nota_fiscal_motivo_recusa : '---'}</span>               
                                                </Alert>                   
                                            </Col>
                                        </Row>
                                    </>
                                    )}
                                </Form>
                            </Card.Body>
                        </Card>
                        <Card className="cardDestaque mt-3">
                            <Card.Body>       
                                <Form onSubmit={this.enviaRegistro}>
                                    <div className="d-flex flex-column">
                                        <div className={origemExameAvulso ? 'order-2' : 'order-1'}>
                                            {origemExameAvulso && <hr></hr>}
                                            <h4>Dados Fiscais</h4>
                                            {bloquearDadosFiscaisPorPagamento && (
                                                <Alert variant="warning" className="mt-3 mb-0">
                                                    Para faturamento de procedimento avulso, primeiro registre o pagamento com comprovante em "Dados de Pagamento". Após isso, o envio da nota fiscal será liberado.
                                                </Alert>
                                            )}
                                    <Row className="mt-4">  
                                        {(this.state.tipo_usuario === "prestador" || this.state.tipo_usuario === 'gestor' || this.state.is_superuser) ? (                               
                                        <Col sm={6} xs={12}>
                                            <Form.Group>
                                                <Form.Label>Nota Fiscal:</Form.Label>
                                                {
                                                (!this.state.nota || this.state.nota_fiscal_status === "recusado") && 
                                                    <Form.Control 
                                                        type="file" 
                                                        name="nota_upload" 
                                                        onChange={this.onChangeArquivo} 
                                                        disabled={bloquearDadosFiscaisPorPagamento}
                                                        ref={this.fileInput} 
                                                    />
                                                } 
                                            </Form.Group>
                                            {this.state.nota && (
                                                <a className="btn btn-secondary btn-sm mt-2" href={this.state.nota} target="_blank">
                                                    <FaFile /> Visualizar Nota Fiscal
                                                </a>
                                            )}
                                        </Col>
                                        ) : (
                                        <Col sm={6} xs={12}>
                                            <Form.Group>
                                                <Form.Label>Nota Fiscal:</Form.Label>
                                            </Form.Group>
                                            {this.state.nota ? (
                                                <a className="btn btn-secondary btn-sm mt-2" href={this.state.nota} target="_blank">
                                                    <FaFile /> Visualizar Nota Fiscal
                                                </a>
                                            ) : (
                                                <p>Aguardando envio da Nota Fiscal</p>
                                            )}
                                        </Col>
                                        )}

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Número da Nota Fiscal</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="nota_fiscal_numero" 
                                                    value={this.state.nota_fiscal_numero} 
                                                    onChange={this.handleNotaNumeroChange} 
                                                    placeholder="Digite o número da nota fiscal"
                                                    disabled={origemExameAvulso ? bloquearDadosFiscaisPorPagamento : this.state.pago}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data de Emissão</Form.Label>
                                                <Form.Control 
                                                    type="date" 
                                                    required 
                                                    placeholder="Data de Emissão" 
                                                    name="data_emissao" 
                                                    value={this.state.data_emissao} 
                                                    onChange={this.handleChange} 
                                                    disabled={origemExameAvulso ? bloquearDadosFiscaisPorPagamento : this.state.pago}
                                                />    
                                            </Form.Group>
                                        </Col>

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data de Vencimento</Form.Label>
                                                <Form.Control 
                                                    type="date" 
                                                    required 
                                                    placeholder="Data de Vencimento" 
                                                    name="data_vencimento" 
                                                    value={this.state.data_vencimento} 
                                                    onChange={this.handleChange} 
                                                    min={currentDate}
                                                    disabled={origemExameAvulso ? bloquearDadosFiscaisPorPagamento : this.state.pago}
                                                />    
                                            </Form.Group>
                                        </Col>

                                        {this.state.tipo_usuario !== "prestador" && this.state.nota && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Aprovação da Nota Fiscal</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="nota_fiscal_status" 
                                                        value={this.state.nota_fiscal_status} 
                                                        disabled={origemExameAvulso ? bloquearDadosFiscaisPorPagamento : this.state.pago}
                                                        required 
                                                        onChange={this.handleNotaStatusChange}>
                                                        <option value="">Selecione o status da Nota Fiscal</option>
                                                        {Object.entries(aprovacaoNota).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {this.state.tipo_usuario !== "prestador" && this.state.nota_fiscal_status === "recusado" && (
                                            <Col sm={12} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Motivo da Recusa</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        name="nota_fiscal_motivo_recusa" 
                                                        value={this.state.nota_fiscal_motivo_recusa} 
                                                        onChange={this.handleNotaRecusaChange} 
                                                        placeholder="Descreva o motivo da recusa" 
                                                        rows={3} 
                                                        required 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                        </div>

                                        <div className={origemExameAvulso ? 'order-1' : 'order-2'}>
                                            {!origemExameAvulso && <hr></hr>}

                                <h4 className={origemExameAvulso ? '' : 'mt-4'}>{origemExameAvulso ? 'Dados de Pagamento (Origem: Exame Avulso)' : 'Dados de Pagamento'}</h4>
                                    {this.state.tipo_usuario !== "prestador" ? (
                                        <>
                                            <Row className="mt-2">
                                                {exibirControlesPagamentoInterno && (
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Situação do Pagamento</Form.Label>
                                                            <Form.Check 
                                                                type="switch" 
                                                                name="pago" 
                                                                id="pago" 
                                                                label="Pago" 
                                                                disabled={bloquearEdicaoPorPagoBanco}
                                                                value="1" 
                                                                checked={this.state.pago ? true : false} 
                                                                onChange={this.handleChange} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                            </Row>

                                            {exibirControlesPagamentoInterno && (
                                                <Row>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Dados para Pagamento (PDF)</Form.Label>
                                                            <Form.Control
                                                                type="file"
                                                                name="arquivo_dados_pagamento"
                                                                accept="application/pdf"
                                                                onChange={this.handleArquivoDadosPagamentoChange}
                                                            />
                                                        </Form.Group>
                                                        {this.state.arquivo_dados_pagamento_url && (
                                                            <a className="btn btn-secondary btn-sm mb-3" href={this.state.arquivo_dados_pagamento_url} target="_blank" rel="noreferrer">
                                                                <FaFile /> Visualizar Dados para Pagamento
                                                            </a>
                                                        )}
                                                    </Col>
                                                </Row>
                                            )}

                                            {exibirControlesPagamentoInterno && this.state.pago && (
                                                <>
                                                    <Row>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Data do Pagamento</Form.Label>
                                                                <Form.Control 
                                                                    type="datetime-local" 
                                                                    name="data_pagamento" 
                                                                    placeholder="Data do pagamento" 
                                                                    value={this.state.data_pagamento || ''} 
                                                                    onChange={this.handleChange} 
                                                                    disabled={bloquearEdicaoPorPagoBanco}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Comprovante (PDF)</Form.Label>
                                                                {!bloquearEdicaoPorPagoBanco && (
                                                                <Form.Control 
                                                                    type="file" 
                                                                    name="pagamento_comprovante" 
                                                                    accept="application/pdf" 
                                                                    placeholder="Comprovante de Pagamento" 
                                                                    onChange={this.handleComprovanteChange} 
                                                                    ref={this.fileInput} 
                                                                />
                                                                )}
                                                            </Form.Group>
                                                            {this.state.pagamento_comprovante_url && (
                                                                <a className="btn btn-secondary btn-sm mb-3" href={this.state.pagamento_comprovante_url} target="_blank">
                                                                    <FaFile /> Visualizar Comprovante
                                                                </a>
                                                            )}
                                                        </Col>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Forma de Pagamento</Form.Label>
                                                                <Form.Control 
                                                                    as="select" 
                                                                    name="pagamento_forma_id" 
                                                                    disabled={bloquearEdicaoPorPagoBanco}
                                                                    onChange={this.handleFormaPagamentoChange} 
                                                                    value={this.state.pagamento_forma_id || ''}>
                                                                    <option value="">Selecione a forma de pagamento utilizada:</option>
                                                                    {this.state.formasPagamento && this.state.formasPagamento.map((formaPagamento) => (
                                                                        <option key={formaPagamento.id} value={formaPagamento.id}>
                                                                            {formaPagamento.nome}
                                                                        </option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    {this.state.pagamento_forma_id && this.state.pagamento_forma_id != this.state.laboratorio_pagamento_forma_id && (
                                                        <Row>
                                                            <Col sm={12} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Motivo da Alteração da Forma de Pagamento</Form.Label>
                                                                    <Form.Control 
                                                                        as="textarea" 
                                                                        name="pagamento_motivo_alteracao" 
                                                                        value={this.state.pagamento_motivo_alteracao} 
                                                                        onChange={this.handleChange} 
                                                                        placeholder="Descreva o motivo da alteração da forma de pagamento" 
                                                                        rows={3} 
                                                                        disabled={bloquearEdicaoPorPagoBanco}
                                                                        required={!origemExameAvulso}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    )}

                                                    {exibirNotaComissao && (
                                                        <Row>
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Número da Nota Fiscal de Comissão</Form.Label>
                                                                    <Form.Control 
                                                                        as="textarea" 
                                                                        name="nota_comissao_numero" 
                                                                        value={this.state.nota_comissao_numero} 
                                                                        onChange={this.handleChange} 
                                                                        rows={1} 
                                                                        disabled={bloquearEdicaoPorPagoBanco} 
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (                                
                                        <Row className="mt-2">
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Selecione a Forma de Pagamento que deseja:</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="laboratorio_pagamento_forma_id" 
                                                        disabled={bloquearEdicaoPorPagoBanco}
                                                        onChange={this.handleChange} 
                                                        value={this.state.laboratorio_pagamento_forma_id || ''}>
                                                        <option value="">Selecione uma forma de pagamento:</option>
                                                        {this.state.formasPagamento && this.state.formasPagamento.map((formaPagamento) => (
                                                            <option key={formaPagamento.id} value={formaPagamento.id}>
                                                                {formaPagamento.nome}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            {this.state.pago && this.state.data_pagamento && (
                                                <Col sm={12} xs={12}>
                                                    <label>Pago em: </label>
                                                    <span> {formataDataHoraExibicao(this.state.data_pagamento)}</span>
                                                </Col>
                                            )}
                                            {this.state.pago && this.state.pagamento_comprovante_url && (
                                                <Col sm={12} xs={12}>
                                                    <a className="btn btn-secondary btn-sm mb-3" href={this.state.pagamento_comprovante_url} target="_blank">
                                                        <FaFile /> Visualizar Comprovante
                                                    </a>
                                                </Col>
                                            )}
                                        </Row>
                                    )}
                                                                
                                    {exibirCamposFormaPagamento && (
                                    <Row className="mt-4">
                                        {
                                        formaPagamentoAtiva && formaPagamentoAtiva.slug == 'boleto' &&
                                        <Col sm={6} xs={12}>
                                            {(origemExameAvulso || (this.state.tipo_usuario == "prestador" && !this.state.pago)) && (
                                            <Form.Group className="mb-3">
                                                <h6 className="mb-3">Boleto Bancário</h6>       
                                                <Form.Label>Arquivo em PDF</Form.Label>
                                                <Form.Control 
                                                    type="file" 
                                                    name="boleto_pagamento" 
                                                    onChange={this.handleBoletoChange}
                                                    disabled={bloquearEdicaoPorPago}
                                                />
                                            </Form.Group>
                                            )}
                                            
                                            {this.state.boleto_pagamento_url && (
                                                <>
                                                    {this.state.tipo_usuario !== 'prestador' && (
                                                        <h6 className="mb-3">Boleto Bancário</h6>
                                                    )}
                                                    <a className="btn btn-secondary btn-sm mb-3" href={this.state.boleto_pagamento_url} target="_blank">
                                                        <FaFile /> Visualizar boleto
                                                    </a>
                                                </>
                                            )}
                                        </Col>
                                        }  

                                        {
                                        formaPagamentoAtiva && formaPagamentoAtiva.slug == 'cartao-de-credito' &&
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <h6 className="mb-3">Cartão de Crédito</h6>
                                                <Form.Label>Link para Pagamento: </Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="pagamento_url_cartao_credito" 
                                                    value={this.state.pagamento_url_cartao_credito} 
                                                    onChange={this.handleTransferenciasChange}
                                                    placeholder="Informe um link de pagamento:"
                                                    disabled={bloquearEdicaoPorPago} 
                                                />
                                                {this.state.pagamento_url_cartao_credito && (
                                                    <a href={this.state.pagamento_url_cartao_credito} target="_blank" rel="noreferrer" className="d-block mt-2">
                                                        {this.state.pagamento_url_cartao_credito}
                                                    </a>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        }  

                                        {
                                        formaPagamentoAtiva && formaPagamentoAtiva.slug == 'pix' &&
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                {!origemExameAvulso && <h6 className="mb-3">PIX</h6>}
                                                <Form.Label>Chave PIX:</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="pagamento_chave_pix" 
                                                    value={this.state.pagamento_chave_pix} 
                                                    onChange={this.handleTransferenciasChange}
                                                    placeholder="Informe a sua chave PIX:"
                                                    disabled={bloquearEdicaoPorPago} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        }                             

                                        {
                                        formaPagamentoAtiva && formaPagamentoAtiva.slug == 'transferencia-bancaria' &&
                                        <>
                                            <h6 className="mb-3">Dados para Transferência</h6>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Banco:</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_banco" 
                                                        value={this.state.pagamento_banco} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder="Informe o Banco:"
                                                        disabled={bloquearEdicaoPorPago} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Agência:</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_agencia" 
                                                        value={this.state.pagamento_agencia} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder="Informe a Agência:" 
                                                        disabled={bloquearEdicaoPorPago}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tipo da Conta:</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="pagamento_tipo_conta"
                                                        disabled={bloquearEdicaoPorPago} 
                                                        value={this.state.pagamento_tipo_conta} 
                                                        onChange={this.handleTransferenciasChange}>
                                                        <option value="corrente">Conta Corrente</option>
                                                        <option value="poupanca">Poupança</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Conta:</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_conta" 
                                                        value={this.state.pagamento_conta} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder="Informe a Conta:"
                                                        disabled={bloquearEdicaoPorPago} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CNPJ/CPF do Titular:</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_titular" 
                                                        value={this.state.pagamento_titular} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder="Informe o CNPJ/CPF do Titular:"
                                                        disabled={bloquearEdicaoPorPago} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        }
                                    </Row>
                                    )}
                                        </div>
                                    </div>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning" className="mt-3">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }

                                    {this.state.tipo_usuario === 'prestador' ? (
                                        <>
                                        {(this.state.nota_fiscal_status === 'recusado' || (!this.state.nota && !this.state.pago)) && (
                                            <Button variant="success" type="submit" className="btn-submit mt-4 mb-3" disabled={this.state.loading}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> Salvar
                                                    </>
                                                )}
                                            </Button>
                                        )}
                                        </>
                                    ) : (
                                        <>
                                        {(!this.state.pago_banco || origemExameAvulso) && (
                                            <Button variant="success" type="submit" className="btn-submit mt-4 mb-3" disabled={this.state.loading}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> Salvar
                                                    </>
                                                )}
                                            </Button>
                                        )}
                                        </>
                                    )}
                                </Form> 
                            </Card.Body>                
                        </Card>

                        <Card className="cardDestaque mt-3">
                            <Card.Body>
                                { this.state.faturamento_credito_antecipacao ? (
                                    <h4>Crédito de Antecipação</h4>
                                ) : (
                                    <h4>{exibirTabelaServicos ? 'Serviços Relacionados' : 'Atendimentos Relacionados'}</h4>
                                )}
                                
                                <Table responsive className="custom-table">
                                    {!this.state.faturamento_credito_antecipacao ?  (
                                        !exibirTabelaServicos ? (
                                            <thead>
                                                <tr>                                    
                                                    <th>ID Atendimento</th>
                                                    <th>Data</th>                                    
                                                    <th>ID do Paciente</th>
                                                    <th>Valor</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                        ) : (
                                            <thead>
                                                <tr>                                    
                                                    <th>ID do Serviço</th>
                                                    <th>ID do Atendimento</th>
                                                    <th>Serviço</th>
                                                    <th>Data</th>                                    
                                                    <th>ID do Paciente</th>
                                                    <th>Nome do Paciente</th>
                                                    <th>Valor</th>
                                                    <th></th>
                                                </tr>
                                            </thead>    
                                        )
                                    ) : (
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Serviço</th>
                                                <th>Data</th>
                                                <th>Prestador</th>
                                                <th>Valor</th>
                                                <th>Quantidade</th>
                                                <th>Valor Total</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                    )}
                                    <tbody>
                                        {this.state.lista_atendimentos.map((item, index) => (
                                            !exibirTabelaServicos ? (
                                                <React.Fragment key={item.id}>  
                                                    <tr>
                                                        <td>{item.atendimento__id || item.id}</td>
                                                        <td>{formataDataHoraExibicao(item.data)}</td>                                    
                                                        <td>{item.beneficiario_id || item.atendimento__beneficiario_id}</td>
                                                        <td>
                                                            <strong>{parseFloat(item.valor_atendimento || item.valor).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong>
                                                            {this.state.nota_fiscal_status != 'aprovado' && !this.state.pago && dados_usuario['tipo_usuario'] != 'prestador' && (
                                                                <>
                                                                    <FaEdit className="ms-2" title="Editar" style={{cursor: 'pointer'}} onClick={() => this.alterarValorServicoAtendimento(item.atendimento__id || item.id, 'atendimento', item.valor_atendimento || item.valor)} />
                                                                    {/*<FaTrash className="ms-2" title="Excluir" style={{cursor: 'pointer'}} onClick={() => this.excluirServicoAtendimento(item)} /> */}
                                                                </>
                                                            )}
                                                        </td>
                                                        <td className="text-end">
                                                        {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                            <FaFileInvoice /> Ver Serviços
                                                        </Button>*/}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>     
                                            ) : (
                                                <React.Fragment key={item.id}>  
                                                    <tr>
                                                        {(() => {
                                                            const atendimentoId = item.atendimento__id || item.exame_solicitado__exame__atendimento__id;
                                                            const atendimentoUuid = item.atendimento__uuid || item.exame_solicitado__exame__atendimento__uuid;
                                                            const dataAtendimento = item.agendamento__data_realizacao || item.data || item.exame_solicitado__exame__atendimento__data;
                                                            const beneficiarioId = item.atendimento__beneficiario_id || item.exame_solicitado__exame__atendimento__beneficiario_id;
                                                            const beneficiarioNome = item.atendimento__beneficiario__nome || item.exame_solicitado__exame__atendimento__beneficiario__nome;

                                                            return (
                                                                <>
                                                        <td>{item.id}</td>                                  
                                                        <td>
                                                            {atendimentoId ? (
                                                                atendimentoUuid ? <a href={`/atendimentos/edit/${atendimentoUuid}`} target="_blank">{atendimentoId}</a> : atendimentoId
                                                            ) : '---'}
                                                        </td>
                                                        <td>{item.servico_procedimento__nome}</td>
                                                        <td>
                                                            {formataDataHoraExibicao(dataAtendimento)}
                                                            {this.state.nota_fiscal_status != 'aprovado' && !this.state.pago && dados_usuario['tipo_usuario'] != 'prestador' && (
                                                                <FaEdit className="ms-2" title="Editar data" style={{cursor: 'pointer'}} onClick={() => this.abrirModalAlteracaoData(item)} />
                                                            )}
                                                        </td>
                                                        <td>{beneficiarioId || '---'}</td>
                                                        <td>{beneficiarioNome || '---'}</td>
                                                        <td><strong>{parseFloat(item.valor).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong>
                                                            {this.state.nota_fiscal_status != 'aprovado' && !this.state.pago && dados_usuario['tipo_usuario'] != 'prestador' && (
                                                                <>
                                                                    <FaEdit className="ms-2" title="Editar" style={{cursor: 'pointer'}} onClick={() => this.alterarValorServicoAtendimento(item.id, 'servico', item.valor)} />
                                                                    <FaTrash className="ms-2" title="Excluir" style={{cursor: 'pointer'}} onClick={() => this.excluirServicoAtendimento(item)} />
                                                                </>
                                                            )}
                                                        </td>
                                                        <td className="text-end">
                                                        {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                            <FaFileInvoice /> Ver Serviços
                                                        </Button>*/}
                                                        </td>
                                                                </>
                                                            )
                                                        })()}
                                                    </tr>
                                                </React.Fragment>     
                                            )
                                        ))}

                                        {!exibirTabelaServicos && 
                                            this.state.lista_historico_atendimentos.map((item, index) => (
                                                <React.Fragment key={item.atendimento_id}>  
                                                <tr className="linha-cancelada">
                                                    <td>{item.atendimento_id}</td>
                                                    <td>{formataDataHoraExibicao(item.atendimento__data)}</td>                                    
                                                    <td>{item.atendimento__beneficiario_id}</td>
                                                    <td><strong>{parseFloat(item.atendimento__valor_atendimento).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    <td className="text-end">
                                                    {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                        <FaFileInvoice /> Ver Serviços
                                                    </Button>*/}
                                                </td>
                                            </tr>
                                            </React.Fragment>     
                                        ))}
                                        {exibirTabelaServicos && 
                                            this.state.lista_historico_atendimentos_servicos.map((item, index) => (
                                                <React.Fragment key={item.atendimento_id}>  
                                                <tr className="linha-cancelada">
                                                    <td>{item.atendimento_servico_id}</td>                                  
                                                    <td><a href={`/atendimentos/edit/${item.atendimento_servico__atendimento__uuid}`} target="_blank">{item.atendimento_servico__atendimento__id}</a></td>
                                                    <td>{item.atendimento_servico__servico_procedimento__nome}</td>
                                                    <td>{formataDataHoraExibicao(item.atendimento_servico__data)}</td>  
                                                    <td>{item.atendimento_servico__atendimento__beneficiario_id}</td>
                                                    <td><strong>{parseFloat(item.atendimento_servico__valor).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    <td className="text-end">
                                                    {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                        <FaFileInvoice /> Ver Serviços
                                                    </Button>*/}
                                                    </td>
                                                </tr>
                                            </React.Fragment>     
                                        ))}

                                        {this.state.faturamento_credito_antecipacao && (
                                            <React.Fragment>  
                                                <tr>
                                                    <td>{this.state.dados_credito_antecipacao[0].id}</td>                                  
                                                    <td>{this.state.dados_credito_antecipacao[0].servico_procedimento__nome}</td>
                                                    <td>{formataDataHoraExibicao(this.state.dados_credito_antecipacao[0].data_criacao)}</td>  
                                                    <td>{this.state.dados_credito_antecipacao[0].prestador__nome}</td>
                                                    <td><strong>{parseFloat(this.state.valor_total / this.state.dados_credito_antecipacao[0].quantidade).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    <td>{this.state.dados_credito_antecipacao[0].quantidade}</td>
                                                    <td>{parseFloat(this.state.valor_total).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</td>
                                                    <td className="text-end"></td>
                                                </tr>
                                            </React.Fragment>  
                                        )}

                                        <tr></tr> 

                                        {this.state.faturamento_credito_antecipacao ? (
                                            <tr className="table-primary">
                                                <td colSpan={6} align="right"><strong>Valor total:</strong> </td>
                                                <td><strong>{parseFloat(this.state.valor_total).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong></td>
                                                <td></td>
                                            </tr> 
                                        ) : (
                                            <tr className="table-primary">
                                                <td colSpan={exibirTabelaServicos ? 6 : 3} align="right"><strong>Valor total:</strong> </td>
                                                <td><strong>{parseFloat(this.state.valor_total).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</strong></td>
                                                <td></td>
                                            </tr> 
                                        )}
                                    </tbody>
                                </Table>                      
                            </Card.Body>
                        </Card>
                    </Tab>
                    {(this.state.id && (dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '')) && (
                    <Tab eventKey="logsFaturamento" title="Logs">
                        <Card className="cardDestaque">
                            <Card.Body>       
                                <h4><strong>Logs do faturamento:</strong></h4>   

                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Descrição</th>
                                            <th>Ação</th>                                              
                                            <th>Usuário</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        this.state.logs_faturamento.map((item) =>
                                        <tr key={item.id}>
                                            <td>
                                                {formataDataHoraExibicao(item.action_time)}
                                            </td>
                                            <td>
                                                {item.change_message ? this.quebraLinhaHistorico(item.change_message) : item.object_repr}
                                            </td>
                                            <td>
                                                {item.action_flag}
                                            </td>
                                            <td>
                                                {item.user__first_name} {item.user__last_name}
                                            </td>
                                        </tr>
                                        )
                                        }                                                                                     
                                    </tbody>                                                                                
                                </Table>
                            </Card.Body>
                        </Card>
                    </Tab>
                    )}
                </Tabs>
                <Modal size="lg" show={this.state.showModalAlteracaoAtendimento} onHide={(e) => this.setState({showModalAlteracaoAtendimento: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.alteracao_servico_atendimento_titulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.enviaRegistroAlteracaoAtendimento}>
                            {this.state.atendimentos_servicos.length > 0 && this.state.atendimentos_servicos.map((servico, index) => (
                                <Row key={index}>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome do Serviço</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nome"
                                                value={servico.dados_servico_procedimento.nome ? servico.dados_servico_procedimento.nome : ''} 
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="valor"
                                                value={servico.valor ? servico.valor : ''} 
                                                onChange={(e) => this.handleChangeAtendimento(e, index, 'valor')}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            ))}
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> Salvar
                                    </>
                                )}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal size="lg" show={this.state.showModalAlteracaoServico} onHide={(e) => this.setState({showModalAlteracaoServico: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.alteracao_servico_atendimento_titulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.enviaRegistroAlteracaoServicoAtendimento}>
                            <Row>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Valor</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="valor_servico_atendimento"
                                            value={this.state.valor_servico_atendimento ? this.state.valor_servico_atendimento : ''}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> Salvar
                                    </>
                                )}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.showModalAlteracaoData} onHide={(e) => this.setState({showModalAlteracaoData: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>Alterar Data do Serviço</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.enviaRegistroAlteracaoData}>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data de Realização do Serviço</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name="data_servico_edicao"
                                            value={this.state.data_servico_edicao}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> Salvar
                                    </>
                                )}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default withRouter(FaturamentosEdit);
